import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { USERAUTH_REALM_BASE_PATH } from '../../../../../features/userauth/realm/userauth-realm-routing';

export const Route = createFileRoute('/_app/_platform/_context-required/realm/_realm')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'realm-list',
        label: 'Realms',
        to: USERAUTH_REALM_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
